import {Injector, NgZone} from '@angular/core';
import {Ng2StateDeclaration} from '@uirouter/angular';
import {UIRouter, UrlParts} from '@uirouter/core';
import {Route as uiRouterRoute} from '../../routes/ui-router';
import {getHistory} from '../history/history';
import {TanStackOutletComponent} from '../outlet/tanstack-outlet.component';
import {AppRouter, getAppRouter} from '../router';
import {TanStackLocationServices} from './tanstack-location.service';

export const TANSTACK_STATE_NAME = 'a.tanstack';

const TANSTACK_STATE: Ng2StateDeclaration = {
  name: TANSTACK_STATE_NAME,
  views: {'main@a': {component: TanStackOutletComponent}},
  params: {
    href: {value: null, dynamic: true},
  },
  data: {requiresAuth: true},
};

function isTanStackUrl(appRouter: AppRouter, url: UrlParts): boolean {
  const [, , foundRoute] = appRouter.getMatchedRoutes(url.path);
  return foundRoute !== undefined && foundRoute.id !== uiRouterRoute.id;
}

function registerTanStackUrlRule(router: UIRouter, appRouter: AppRouter): void {
  const rules = router.urlService.rules;
  const rule = rules.urlRuleFactory.create(
    (url: UrlParts) => isTanStackUrl(appRouter, url),
    () => {
      const href = router.urlService.url();
      const {current, params} = router.globals;
      if (current.name !== TANSTACK_STATE_NAME || params.href !== href) {
        router.stateService.transitionTo(TANSTACK_STATE_NAME, {href}, {source: 'url'});
      }
    },
  );
  rule.priority = 1;
  rules.rule(rule);
}

export function tanStackUiRouterHook(router: UIRouter, injector: Injector): void {
  const ngZone = injector.get(NgZone);
  router.locationService.dispose(router);
  router.locationService = new TanStackLocationServices(router, getHistory(), ngZone);
  router.disposable(router.locationService);

  const appRouter = ngZone.runOutsideAngular(() => getAppRouter());
  router.stateRegistry.register(TANSTACK_STATE);
  registerTanStackUrlRule(router, appRouter);
}
